/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Short_Shipments_To_CreditInputs */

const en_queue_short_shipments_to_credit = /** @type {(inputs: Queue_Short_Shipments_To_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short shipments to credit`)
};

/**
* | output |
* | --- |
* | "Short shipments to credit" |
*
* @param {Queue_Short_Shipments_To_CreditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_short_shipments_to_credit = /** @type {((inputs?: Queue_Short_Shipments_To_CreditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Short_Shipments_To_CreditInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_short_shipments_to_credit(inputs)
});